import React, { useState } from "react";
import styles from "./documentcard.module.css";
import { MdDelete } from "react-icons/md";
import { TfiArrowCircleDown, TfiArrowCircleUp } from "react-icons/tfi";
import { MdEdit } from "react-icons/md";
import Toggle from "../../../../Components/Common/Toggle";
import { toast } from "react-toastify";
import { DocApi } from "../../../../App/api/document.apis";

const DocumentCard = ({
  item,
  fetchAllData,
  handleDocumentEdit,
  handleDocumentDelete,
}) => {
  const [toggleValues, setToggleValues] = useState({
    is_mandatory: item.is_mandatory,
    is_visible: item.is_visible,
    is_expiry_date: item.is_expiry_date,
    is_unique_code: item.is_unique_code,
  });

  const handleToggleChange = async (toggleName) => {
    const newValue = !toggleValues[toggleName];
    setToggleValues((prev) => ({
      ...prev,
      [toggleName]: newValue,
    }));

    try {
      await DocApi.updateDocument(
        {
          ...item,
          [toggleName]: newValue,
        },
        item._id
      );
      fetchAllData();
      toast.success("Document updated successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update document");
    }
  };

  const [arrow, setArrow] = useState(false);

  return (
    <>
      <div className={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <div>
            <p style={{ fontSize: "1.1rem", textTransform: "capitalize" }}>
              {item.name}
            </p>
            <p style={{ marginTop: "", textTransform: "capitalize" }}>
              {item.userRole?.name}
            </p>
          </div>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <MdEdit
              size={"1.5rem"}
              className={styles.arrow}
              onClick={() => handleDocumentEdit(item)}
            />
            <MdDelete
              size={"1.5rem"}
              className={styles.arrow_Del}
              onClick={() => handleDocumentDelete(item._id)}
            />
            {arrow ? (
              <TfiArrowCircleUp
                size={"1.5rem"}
                className={styles.arrow}
                onClick={() => setArrow(!arrow)}
              />
            ) : (
              <TfiArrowCircleDown
                size={"1.5rem"}
                className={styles.arrow}
                onClick={() => setArrow(!arrow)}
              />
            )}
          </div>
        </div>
        <div
          className={styles.items}
          style={{ height: arrow ? "170px" : "0px" }}
        >
          <div>
            <div style={{ display: "flex", gap: "1rem", marginTop: "1.4rem" }}>
              <Toggle
                onChange={() => handleToggleChange("is_mandatory")}
                value={toggleValues.is_mandatory}
              />
              <p>Is this document mandatory ?</p>
            </div>
            <div style={{ display: "flex", gap: "1rem", marginTop: "1.4rem" }}>
              <Toggle
                onChange={() => handleToggleChange("is_visible")}
                value={toggleValues.is_visible}
              />
              <p>Document visible ?</p>
            </div>
            <div style={{ display: "flex", gap: "1rem", marginTop: "1.4rem" }}>
              <Toggle
                onChange={() => handleToggleChange("is_expiry_date")}
                value={toggleValues.is_expiry_date}
              />
              <p>Is document have expiry date ?</p>
            </div>
            <div style={{ display: "flex", gap: "1rem", marginTop: "1.4rem" }}>
              <Toggle
                onChange={() => handleToggleChange("is_unique_code")}
                value={toggleValues.is_unique_code}
              />
              <p>Is document have unique code ?</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentCard;
